module.exports = __webpack_public_path__ + "static/media/logo_hooli.7d22753c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/logos/logo_hooli.svg
// module id = 344
// module chunks = 0